import React, { useState } from "react";
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/login-image.jpg";

import { useAuth } from "../../auth-context/auth.context";
import AuthApi from "../../api/auth";

import { useHistory } from "react-router-dom";

function SignIn() {
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");
  const history = useHistory();
  const { setUser } = useAuth();
  const { user } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(undefined);
  const [buttonText, setButtonText] = useState("Ingresar");

  const login = async (event) => {
    if (event) {
      event.preventDefault();
    }
    if (user && user.token) {
      return history.push("/dashboard");
    }
    if (email === "") {
      return setError("Debe ingresar su correo.");
    }
    if (password === "") {
      return setError("Debe ingresar su contraseña.");
    }
    setButtonText("Ingresando");
    try {
      let response = await AuthApi.Login({
        email,
        password,
      });
      if (response.data && response.data.success === false) {
        setButtonText("Ingresar");
        return setError(response.data.msg);
      }
      return setProfile(response);
    } catch (err) {
      console.log(err);
      setButtonText("Ingresar");
      if (err.response) {
        return setError(err.response.data.msg);
      }
      return setError("Ha ocurrido un error.");
    }
  };

  const setProfile = async (response) => {
    let user = { ...response.data.user };
    user.token = response.data.token;
    user = JSON.stringify(user);
    setUser(user);
    localStorage.setItem("user", user);
    return history.push("/dashboard");
  };

  return (
    <Flex position="fixed" top="0" left="0" w="100vw" h="100vh" zIndex="999" bg="white" overflow="hidden">
      <Flex
        h="100%"
        w="100%"
        maxW="1100px"
        mx="auto"
        justifyContent="space-between"
        mb="0px"
        pt={{ sm: "100px", md: "0px" }}
      >
        <Flex
          alignItems="center"
          justifyContent="start"
          style={{ userSelect: "none" }}
          w={{ base: "100%", md: "50%", lg: "42%" }}
        >
          {user && user.token ?
            <div>
              <Heading color={titleColor} fontSize="32px" mt="10px" mb="10px">
                Welcome Back
              </Heading>
              <h3 style={{ textAlign: "center" }}>You are already signed in.</h3>
              <Button
                fontSize="15px"
                type="submit"
                bg="teal.300"
                w="100%"
                h="45"
                mb="20px"
                color="white"
                mt="20px"
                _hover={{
                  bg: "teal.200",
                }}
                _active={{
                  bg: "teal.400",
                }}
                onClick={login}>
                {`Let's go`}
              </Button>
            </div>
            :
            <Flex
              direction="column"
              w="100%"
              background="white"
              boxShadow="0px 4px 12px rgba(0, 0, 0, 0.05)"
              borderRadius="15px"
              p="40px"
              mx="auto"
              justifyContent="center"
              height="auto"
              maxW="450px"
            >
              <Box mb="30px" textAlign="center">
                <img src="https://administracion.dlds.cl/newdlds/logodldsnew.svg" alt="Logo" width="180" style={{ margin: "0 auto" }} />
                <Text
                  mt="10px"
                  color="gray.400"
                  fontWeight="bold"
                  fontSize="md"
                >
                  Bienvenido al Sistema de Picking
                </Text>
              </Box>
              <FormControl>
                <FormLabel ms="4px" fontSize="sm" fontWeight="medium" color="gray.500">
                  Correo Electrónico
                </FormLabel>
                <Input
                  borderRadius="10px"
                  mb="24px"
                  fontSize="sm"
                  type="text"
                  placeholder="ejemplo@dlds.cl"
                  size="lg"
                  variant="filled"
                  defaultValue={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setError(undefined);
                  }}
                  _focus={{ borderColor: "teal.300", bg: "white" }}
                />
                <FormLabel ms="4px" fontSize="sm" fontWeight="medium" color="gray.500">
                  Contraseña
                </FormLabel>
                <Input
                  borderRadius="10px"
                  mb="20px"
                  fontSize="sm"
                  type="password"
                  placeholder="Escribe tu contraseña"
                  size="lg"
                  variant="filled"
                  defaultValue={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError(undefined);
                  }}
                  _focus={{ borderColor: "teal.300", bg: "white" }}
                />
                <FormControl display="flex" alignItems="center" mb="24px">
                  <Switch id="remember-login" colorScheme="teal" me="10px" />
                  <FormLabel
                    htmlFor="remember-login"
                    mb="0"
                    fontWeight="normal"
                    color="gray.500"
                    fontSize="sm"
                  >
                    Mantener sesión iniciada
                  </FormLabel>
                </FormControl>

                {error && (
                  <Box mb="20px" p="10px" bg="red.50" borderRadius="md" borderLeft="4px solid red">
                    <Text color="red.500" fontSize="sm" fontWeight="medium">
                      {error}
                    </Text>
                  </Box>
                )}

                <Button
                  fontSize="sm"
                  variant="solid"
                  fontWeight="bold"
                  colorScheme="teal"
                  w="100%"
                  h="50"
                  mb="24px"
                  onClick={login}
                >
                  {buttonText}
                </Button>
              </FormControl>
            </Flex>
          }
        </Flex>
        <Box
          display={{ base: "none", md: "block" }}
          overflowX="hidden"
          h="100%"
          w="40vw"
          position="absolute"
          right="0px"
        >
          <Box
            bgImage={signInImage}
            w="100%"
            h="100%"
            bgSize="cover"
            bgPosition="50%"
            position="absolute"
          ></Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SignIn;
